export const RANGE_OPTIONS = [
  {
    key: 'price',
    field: 'price.offer',
    translation: 'filter.price',
    showBars: false,
  },
  {
    key: 'productRating',
    field: 'product.user_reviews.rating',
    translation: 'filter.product-rating',
    showBars: true,
  },
  {
    key: 'storeRating',
    field: 'store.user_reviews.rating',
    translation: 'filter.store-rating',
    showBars: true,
  },
];

export const DEFAULT_VISIBLE_STORES = 5;
